module.exports = __webpack_public_path__ + "static/media/z&v6.dffca845.jpg";